import React, {useState, SyntheticEvent, useEffect} from "react";
import {useTranslation} from "next-i18next";
import {ProfileCard} from "./profile-card";
import {LoadingButton} from "@mui/lab";
import {useSelector, useDispatch} from "../../store";
import {updateProfileBio} from "../../slices/user-session-slice";
import {Collapse, TextField, CardActions, Box} from "@mui/material";

export const BioCard = () => {
    const {t} = useTranslation();

    const {isUpdatingProfile, currentProfile: {bio}} = useSelector((state) => state.userSession);

    const dispatch = useDispatch()

    const [editedBio, setEditedBio] = useState(bio);
    const [editing, setEditing] = useState(false);

    const handleEditChange = (newEditing: boolean) => {
        setEditing(newEditing);
        if (newEditing) {
            setEditedBio(bio)
        }
    };

    useEffect(() => {

        if (!isUpdatingProfile && editing) {
            setEditing(false)
        }

    }, [isUpdatingProfile])

    const handleChange = (event: any) => {
        setEditedBio(event.target.value);
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        dispatch(updateProfileBio(editedBio))
    };

    return (
        <ProfileCard
            title={t("bio")}
            editing={editing}
            onEditingChanged={handleEditChange}
        >
            {editing ? (
                <Collapse in={editing}>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            autoFocus={true}
                            name="bio"
                            id="bio"
                            variant="outlined"
                            style={{backgroundColor: "white"}}
                            placeholder={t("bio-placeholder")}
                            multiline
                            maxRows="5"
                            minRows="3"
                            onChange={handleChange}
                            value={editedBio}
                            margin="none"
                            fullWidth
                        />
                        <CardActions style={{justifyContent: "flex-end"}}>
                                <LoadingButton
                                    loading={isUpdatingProfile}
                                    disabled={isUpdatingProfile}
                                    type="submit"
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                >
                                    {t("save")}
                                </LoadingButton>
                        </CardActions>
                    </form>
                </Collapse>
            ) : (
                <Box mt={1} style={{whiteSpace: "pre-wrap"}}>
                    {bio}
                </Box>
            )}
        </ProfileCard>
    );
}
